export const SESSION_RESTORE_RETRY_MS: readonly number[] = [
  1_000, 2_000, 3_000, 5_000, 5_000, 5_000, 10_000, 10_000, 10_000,
];
